import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toolbar"]

  initialize() {
    this.renderAttachmentToolbar()
    this.displayAttachments()
  }

  displayAttachments(event) {
    if (event) {
      this.renderAttachments(event.detail.editorId)
    } else {
      const target = this.toolbarTarget
      const editorElement = target.parentNode.querySelector("trix-editor")
      const editorId = editorElement.id

      this.renderAttachments(editorId)
    }
  }

  renderAttachments(editorId) {
    const editorElement = document.querySelector(`trix-editor#${editorId}`)
    const editor = editorElement.editor
    const attachments = editor.getDocument().getAttachmentPieces()
    const target = editorElement.parentNode.querySelector(".attachments-toolbar")

    target.innerHTML = ""
    attachments.map((node) => {
      const attachment = node.attachment
      const contentType = attachment?.attributes?.values?.contentType
      const type = attachment?.attributes?.values?.type
      const isImage = contentType?.includes("image")
      const isVideo = type === "video"

      if (!isImage && !isVideo) {
        target.innerHTML += `
          <div class="attachment-container grey">
            <div class="attachment-title" title="${attachment.attributes.values.filename}">
              ${attachment.attributes.values.filename}
            </div>
            ${this.niceBytes(attachment.attributes.values.filesize)}
            <a class="attachment-remove" data-target-editor-id="${editorId}" data-attachment-id="${attachment.id}" data-action="click->attachments#removeAttachment">Remove</a>
          </div>
        `
      }
    })

    this.renderAttachmentToolbar()
  }

  removeAttachment(event) {
    const target = event.target
    const attachmentId = Number(target.dataset.attachmentId)
    const targetEditorId = target.dataset.targetEditorId
    const targetEditor = document.querySelector(`trix-editor#${targetEditorId}`).editor

    const attachment = targetEditor.getDocument().getAttachmentById(attachmentId)

    targetEditor.composition.removeAttachment(attachment)
  }

  renderAttachmentToolbar() {
    const target = this.toolbarTarget
    const editor = target.parentNode.querySelector("trix-editor").editor
    const attachments = editor.getDocument().getAttachmentPieces()

    if (attachments.length === 0) {
      target.classList.add("d-none")
    } else {
      target.classList.remove("d-none")
    }
  }

  niceBytes(value) {
    const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    let l = 0,
      n = parseInt(value, 10) || 0

    while (n >= 1024 && ++l) {
      n = n / 1024
    }

    return `(${n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l]})`
  }
}
